import useApi from './useApi';

const useEstablishmentService = () => {
  const { api } = useApi();

  const getOwnEstablishment = () => api({
    method: 'get',
    url: '/identity-access/v1/establishments/own',
  });

  const getAllEstablishments = () => api({
    method: 'get',
    url: '/identity-access/v1/establishments',
  });

  const postEstablishment = ({ name }) => api({
    method: 'post',
    url: '/identity-access/v1/establishments',
    data: {
      name,
    },
  });

  const postUpdateStatus = ({ establishmentId, isActive }) => {
    const state = isActive ? 'activate' : 'deactivate';

    return api({
      method: 'post',
      url: `/identity-access/v1/establishments/${establishmentId}:${state}`,
    });
  };

  return {
    getAllEstablishments,
    getOwnEstablishment,
    postEstablishment,
    postUpdateStatus,
  };
};

export default useEstablishmentService;
